// Radio fields data
import { theme } from "@common/theme/theme"
import moment from "moment"
import "moment/locale/fr"
import * as yup from "yup"
import {
    postcodeValidator,
    postcodeValidatorExistsForCountry,
} from "postcode-validator"
import countries from "i18n-iso-countries"
import frLocale from "i18n-iso-countries/langs/fr.json"
import {
    studentMotifOptions,
    tutorMotifOptions,
} from "./attributionTicketConstants"

export const studentClasses = [
    "CP",
    "CE1",
    "CE2",
    "CM1",
    "CM2",
    "6ème",
    "5ème",
    "4ème",
    "3ème",
    "2nde",
    "1ère",
    "Tle",
    "Autre",
]

// CP et CE1 se choisissent dans le profil et le contenu, pas dans les tunnels
// d'acquisition (inscription, essai), qui commencent au CE2.
const classesOutsideAcquisition = ["CP", "CE1"]
export const acquisitionStudentClasses = studentClasses.filter(
    (x) => !classesOutsideAcquisition.includes(x)
)

export const sportOptions = [
    "Athlétisme",
    "Baseball",
    "Basketball",
    "Boxe",
    "Cyclisme",
    "Danse",
    "Escalade",
    "Escrime",
    "Football",
    "Gym acrobatique",
    "Gymnastique",
    "Handball",
    "Judo",
    "Karaté",
    "Natation",
    "Paddle",
    "Roller",
    "Rugby",
    "Skateboard",
    "Ski",
    "Snowboard",
    "Softball",
    "Surf",
    "Taekwondo",
    "Tennis",
    "Volleyball",
]
export const sectionStudentClasses = [
    {
        title: "Primaire",
        options: ["CP", "CE1", "CE2", "CM1", "CM2"],
    },
    {
        title: "Collège",
        options: ["6ème", "5ème", "4ème", "3ème"],
    },
    {
        title: "Lycée",
        options: ["2nde", "1ère", "Tle"],
    },
    {
        title: "Autre",
        options: ["Autre"],
    },
]

export const activityStatuses = [
    {
        label: "Validé",
        value: "validated",
    },
    {
        label: "Rejeté",
        value: "rejected",
    },
    {
        label: "Fait",
        value: "not_reviewed",
    },
    {
        label: "En attente",
        value: "pending_review",
    },
]

export const days = [
    { value: "Monday", label: "L" },
    { value: "Tuesday", label: "Ma" },
    { value: "Wednesday", label: "Me" },
    { value: "Thursday", label: "J" },
    { value: "Friday", label: "V" },
    { value: "Saturday", label: "S" },
    { value: "Sunday", label: "D" },
]

export const daysOptions = [
    { value: "Monday", label: "Lundi" },
    { value: "Tuesday", label: "Mardi" },
    { value: "Wednesday", label: "Mercredi" },
    { value: "Thursday", label: "Jeudi" },
    { value: "Friday", label: "Vendredi" },
    { value: "Saturday", label: "Samedi" },
    { value: "Sunday", label: "Dimanche" },
]
export const roomTypes = [
    { value: "study_group", label: "Étude encadrée" },
    { value: "biweekly", label: "Cours partagé" },
    { value: "individual", label: "Individuel" },
    { value: "holiday_course", label: "Stage" },
    { value: "holiday_workbook", label: "Cours d'été" },
    { value: "trial", label: "Essai" },
    { value: "support", label: "Support" },
    { value: "custom", label: "Tutoriel" },
]
// Gender
export const gender = ["Masculin", "Féminin"]

// interviewDays
export const interviewDays = ["Saturday", "Sunday"]

export const channels = [
    { label: "Famille/amis", value: "Famille/amis" },
    { label: "Actualités/article/blog", value: "Actualités/article/blog" },
    { label: "Facebook/Instagram", value: "Facebook/Instagram" },
    { label: "Recherche Google", value: "Recherche Google" },
    { label: "Partenaire", value: "Partenaire" },
    { label: "Autre", value: "Autre" },
]
export const favorite_subjects = [
    { value: "Maths", label: "Maths" },
    { value: "Physique-Chimie", label: "Physique-Chimie" },
    { value: "SVT", label: "SVT" },
    { value: "Français,", label: "Français" },
    { value: "Anglais,", label: "Anglais" },
    { value: "Espagnol,", label: "Espagnol" },
    { value: "Allemand,", label: "Allemand" },
    { value: "Histoire-Géographie,", label: "Histoire-Géographie" },
    { value: "Musique,", label: "Musique" },
    { value: "Sport,", label: "Sport" },
]

export const subjectPriorities = [
    { label: "Scientifiques (Maths, Physique...)", value: "scientific" },
    {
        label: "Littéraires (Français, Histoire-Géo, SES...)",
        value: "literary",
    },
    // {label: 'Langues (Anglais, Espagnol, Allemand...)', value: 'language'}
    // {label: 'Autre', value: 'other'}
]

export const subjectPrioritiesSing = [
    { label: "Scientifique (Maths, Physique...)", value: "scientific" },
    { label: "Littéraire (Français, Histoire-Géo, SES...)", value: "literary" },
    // {label: 'Langues (Anglais, Espagnol, Allemand...)', value: 'language'}
    // {label: 'Autre', value: 'other'}
]

export const subjectPrioritiesSingWithNullOption = [
    { label: "Scientifique (Maths, Physique...)", value: "scientific" },
    { label: "Littéraire (Français, Histoire-Géo, SES...)", value: "literary" },
    { label: "Aide aux devoirs toutes matières", value: null },
]

export const subjectPrioritiesSingLight = [
    { label: "Scientifique", value: "scientific" },
    { label: "Littéraire", value: "literary" },
    // {label: 'Langues (Anglais, Espagnol, Allemand...)', value: 'language'}
    // {label: 'Autre', value: 'other'}
]

export const subjectPrioritiesSingLightWithNullOption = [
    { label: "Scientifique", value: "scientific" },
    { label: "Littéraire", value: "literary" },
    { label: "Aide aux devoirs toutes matières", value: null },
]

export const subjectPrioritiesSubjectsDisplay = {
    scientific: ["Maths", "Physique", "+3"],
    literary: ["Français", "SES", "+2"],
    "scientific,literary": ["Maths", "Français", "+5"],
    "literary,scientific": ["Maths", "Français", "+5"],
}

export const slotsPossibleOptions = [
    { label: "Lundi 18h-20h", value: "Lundi 18h-20h" },
    { label: "Mardi 18h-20h", value: "Mardi 18h-20h" },
    { label: "Mercredi 14h-16h", value: "Mercredi 14h-16h" },
    { label: "Mercredi 16h-18h", value: "Mercredi 16h-18h" },
    { label: "Mercredi 18h-20h", value: "Mercredi 18h-20h" },
    { label: "Jeudi 18h-20h", value: "Jeudi 18h-20h" },
    { label: "Vendredi 18h-20h", value: "Vendredi 18h-20h" },
    { label: "Samedi 8h-10h", value: "Samedi 8h-10h" },
    { label: "Samedi 10h-12h", value: "Samedi 10h-12h" },
    { label: "Samedi 14h-16h", value: "Samedi 14h-16h" },
    { label: "Samedi 16h-18h", value: "Samedi 16h-18h" },
    { label: "Samedi 18h-20h", value: "Samedi 18h-20h" },
    { label: "Dimanche 8h-10h", value: "Dimanche 8h-10h" },
    { label: "Dimanche 10h-12h", value: "Dimanche 10h-12h" },
    { label: "Dimanche 14h-16h", value: "Dimanche 14h-16h" },
    { label: "Dimanche 16h-18h", value: "Dimanche 16h-18h" },
    { label: "Dimanche 18h-20h", value: "Dimanche 18h-20h" },
]
export const slotsPossibleWeekendOptions = [
    { label: "Samedi 8h-10h", value: "Samedi 8h-10h" },
    { label: "Samedi 10h-12h", value: "Samedi 10h-12h" },
    { label: "Samedi 14h-16h", value: "Samedi 14h-16h" },
    { label: "Samedi 16h-18h", value: "Samedi 16h-18h" },
    { label: "Samedi 18h-20h", value: "Samedi 18h-20h" },
    { label: "Dimanche 8h-10h", value: "Dimanche 8h-10h" },
    { label: "Dimanche 10h-12h", value: "Dimanche 10h-12h" },
    { label: "Dimanche 14h-16h", value: "Dimanche 14h-16h" },
    { label: "Dimanche 16h-18h", value: "Dimanche 16h-18h" },
    { label: "Dimanche 18h-20h", value: "Dimanche 18h-20h" },
]
export const slotsPossibleRegularDaysOptions = [
    { label: "Lundi 18h-20h", value: "Lundi 18h-20h" },
    { label: "Mardi 18h-20h", value: "Mardi 18h-20h" },
    { label: "Mercredi 14h-16h", value: "Mercredi 14h-16h" },
    { label: "Mercredi 16h-18h", value: "Mercredi 16h-18h" },
    { label: "Mercredi 18h-20h", value: "Mercredi 18h-20h" },
    { label: "Jeudi 18h-20h", value: "Jeudi 18h-20h" },
    { label: "Vendredi 18h-20h", value: "Vendredi 18h-20h" },
]
export const qualities = [
    { value: "Ambitieux", label: "Ambitieux" },
    { value: "Aventurier", label: "Aventurier" },
    { value: "Bienveillant", label: "Bienveillant" },
    { value: "Conciliant", label: "Conciliant" },
    { value: "Volontaire", label: "Volontaire" },
    { value: "Travailleur", label: "Travailleur" },
    { value: "Sympathique", label: "Sympathique" },
    { value: "Souple", label: "Souple" },
    { value: "Sociable", label: "Sociable" },
    { value: "Sobre", label: "Sobre" },
    { value: "Serviable", label: "Serviable" },
    { value: "Rusé", label: "Rusé" },
    { value: "Respectueux", label: "Respectueux" },
    { value: "Prévoyant", label: "Prévoyant" },
    { value: "Ponctuel", label: "Ponctuel" },
    { value: "Patient", label: "Patient" },
    { value: "Organisé", label: "Organisé" },
    { value: "Modeste", label: "Modeste" },
    { value: "Minutieux", label: "Minutieux" },
    { value: "Mature", label: "Mature" },
    { value: "Leader", label: "Leader" },
    { value: "Intuitif", label: "Intuitif" },
    { value: "Ingénieux", label: "Ingénieux" },
    { value: "Généreux", label: "Généreux" },
    { value: "Enthousiaste", label: "Enthousiaste" },
    { value: "Discipliné", label: "Discipliné" },
    { value: "Diplomate", label: "Diplomate" },
    { value: "Diplomate", label: "Diplomate" },
    { value: "Déterminé", label: "Déterminé" },
    { value: "Curieux", label: "Curieux" },
    { value: "Créatif", label: "Créatif" },
    { value: "Courageux", label: "Courageux" },
]

//profession
export const professionalSituation = ["Etudiant", "Professionnel"]
export const productColors = {
    integral: theme.colors.material.secondary?.["900"],
    essential: theme.colors.material.secondary?.["600"],
    initial: theme.colors.material.secondary?.["300"],
    holidaycourse: theme.colors.material.secondary?.["600"],
    premium: theme.colors.warning,
    plus: theme.colors.accent,
    basic: theme.colors.lightMore,
}

export const groupAttributionStatusNames = {
    unpublished: "Non publiée",
    published: "Publiée - En cours",
    completed: "Publiée - Complet",
    closed: "Clôturée",
}

export const groupAttributionStatusColors = {
    unpublished: theme.colors.info,
    published: theme.colors.accentDark,
    completed: theme.colors.success,
    closed: theme.colors.light,
}

export const groupAttributionTypeConfigs = {
    regular: {
        label: "Régulier",
        icon: "users",
        color: theme.colors.primary,
        value: "regular",
    },
    trial: {
        label: "Essai",
        icon: "flask",
        color: theme.colors.success,
        value: "trial",
    },
    temporary: {
        label: "Attribution Temporaire",
        icon: "exchange-alt",
        color: theme.colors.warning,
        value: "temporary",
    },
    adhoc: {
        label: "Adhoc",
        icon: "user-plus",
        color: theme.colors.purple,
        value: "adhoc",
    },
}

export const getGroupAttributionType = (row) => {
    if (row?.is_trial) return "trial"
    if (row?.is_temporary_absence) return "temporary"
    if (row?.is_adhoc) return "adhoc"
    return "regular"
}

export const groupAttributionProposalStatusNames = {
    pending: "En attente",
    accepted: "Candidatée",
    rejected: "Masquée",
    expired: "Expirée",
    chosen: "Retenu",
    not_chosen: "Non retenu",
    accepted_canceled: "Candidat (conflit)",
}

export const groupAttributionProposalStatusColors = {
    pending: theme.colors.accentDark,
    accepted: theme.colors.primaryLight,
    rejected: theme.colors.light,
    expired: theme.colors.light,
    chosen: theme.colors.success,
    not_chosen: theme.colors.error,
    default: theme.colors.white,
    accepted_canceled: theme.colors.warning,
}

export const substitutionProposalStatusNames = {
    pending: "En attente",
    accepted: "Acceptée",
    rejected: "Masquée",
    expired: "Expirée",
    accepted_canceled: "Candidat (conflit)",
}

export const substitutionProposalStatusColors = {
    pending: theme.colors.accentDark,
    accepted: theme.colors.success,
    rejected: theme.colors.error,
    expired: theme.colors.light,
    accepted_canceled: theme.colors.warning,
}

export const subscriptionStatusColors = {
    recurring: theme.colors.successDark,
    past_due: theme.colors.error,
    on_grace_period: theme.colors.accent,
    on_grace_period_before_pause: theme.colors.warning,
    planned_subscription_update: theme.colors.warning,
    on_trial: theme.colors.successDark,
    paused: theme.colors.light,
    planned: theme.colors.success,
    ended: theme.colors.light,
    on_generic_trial: theme.colors.success,
    expired_trial: theme.colors.light,
}

export const subscriptionStatusNames = {
    recurring: "RÉCURRENT",
    past_due: "EN RETARD",
    on_grace_period: "ACTIF AVEC ÉCHÉANCE",
    on_grace_period_before_pause: "PAUSE PLANIFIÉE",
    planned_subscription_update: "MODIF PLANIFIÉE",
    on_trial: "ESSAI PRÉ-ABO",
    paused: "MIS EN PAUSE",
    planned: "PLANIFIÉ",
    ended: "TERMINÉ",
    on_generic_trial: "ESSAI GRATUIT",
    expired_trial: "ESSAI EXPIRÉ",
}

export const subscribedProductNames = {
    initial: "Offre Initiale",
    essential: "Offre Essentielle",
    integral: "Offre Intégrale",
}

export const subscribedProducts = [
    {
        title: "Sélectionner tout",
        data: [
            {
                label: "Intégrale",
                value: "integral-student",
            },
            {
                label: "Essentielle",
                value: "essential-student",
            },
            {
                label: "Initiale",
                value: "initial-student",
            },
            {
                label: "Stage",
                value: "holidaycourse-student",
            },
            {
                label: "Premium",
                value: "premium-student",
            },
            {
                label: "Plus",
                value: "plus-student",
            },
            {
                label: "Basic",
                value: "student",
            },
        ],
    },
]

export const subscriptionStates = [
    {
        title: "Sélectionner tout",
        data: [
            {
                label: "Essai gratuit <=7",
                value: "on_generic_trial_<=7",
            },
            {
                label: "Essai gratuit >7",
                value: "on_generic_trial_>7",
            },
            {
                label: "Abonné",
                value: "subscribed",
            },
            {
                label: "Abonnement terminé",
                value: "ended",
            },
            {
                label: "Jamais abonné",
                value: "never_subscribed",
            },
        ],
    },
]

export const roomTypesFilter = [
    {
        title: "Sélectionner tout",
        data: roomTypes,
    },
]

export const liveDaysFilter = [
    {
        title: "Sélectionner tout",
        data: daysOptions,
    },
]

export const availabilityFilter = [
    {
        title: "Sélectionner tout",
        data: [
            {
                label: "Complet",
                value: "full",
            },
            {
                label: "Place(s) disponible(s)",
                value: "available",
            },
        ],
    },
]

moment.locale("fr")

export const dateOptions = [
    {
        label: moment().format("ddd DD/MM"),
        value: moment().format("YYYY-MM-DD"),
    },
    {
        label: moment().add(1, "days").format("ddd DD/MM"),
        value: moment().add(1, "days").format("YYYY-MM-DD"),
    },
    {
        label: moment().add(2, "days").format("ddd DD/MM"),
        value: moment().add(2, "days").format("YYYY-MM-DD"),
    },
    {
        label: moment().add(3, "days").format("ddd DD/MM"),
        value: moment().add(3, "days").format("YYYY-MM-DD"),
    },
    {
        label: moment().add(4, "days").format("ddd DD/MM"),
        value: moment().add(4, "days").format("YYYY-MM-DD"),
    },
    {
        label: moment().add(5, "days").format("ddd DD/MM"),
        value: moment().add(5, "days").format("YYYY-MM-DD"),
    },
    {
        label: moment().add(6, "days").format("ddd DD/MM"),
        value: moment().add(6, "days").format("YYYY-MM-DD"),
    },
]

export const availabilityOptions = [
    {
        label: "lun.",
        value: "Monday",
    },
    {
        label: "mar.",
        value: "Tuesday",
    },
    {
        label: "mer.",
        value: "Wednesday",
    },
    {
        label: "jeu.",
        value: "Thursday",
    },
    {
        label: "ven.",
        value: "Friday",
    },
    {
        label: "sam.",
        value: "Saturday",
    },
    {
        label: "dim.",
        value: "Sunday",
    },
]

export const liveOccurrenceDatesFilter = [
    {
        title: "Sélectionner tout",
        data: dateOptions,
    },
]

const nbStudentsOptions = [
    { value: "0", label: "0" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "3_plus", label: "3+" },
]

export const nbStudentsFilter = [
    {
        title: "Sélectionner tout",
        data: nbStudentsOptions,
    },
]

const tutorDomains = [
    { value: "literary", label: "littéraire" },
    { value: "scientific", label: "scientifique" },
]

export const tutorDomainsFilter = [
    {
        title: "Sélectionner tout",
        data: tutorDomains,
    },
]

const studentClassesOptions = studentClasses.map((c) => ({ value: c, label: c }))

export const studentClassesFilter = [
    {
        title: "Sélectionner tout",
        data: studentClassesOptions,
    },
]

export const yesNoFilter = [
    { value: true, label: "Oui" },
    { value: "", label: "Non" },
]

export const interviewReportState = [
    {
        title: "Sélectionner tout",
        data: [
            {
                label: "À jour (d<=26)",
                value: "ok",
            },
            {
                label: "À traiter (26<d<=29)",
                value: "todo",
            },
            {
                label: "En retard (d>29), au moins un rapport",
                value: "late",
            },
            {
                label: "En retard (29<d<=60), aucun rapport",
                value: "late_never",
            },
            {
                label: "En retard (d>60), aucun rapport",
                value: "late_never_old",
            },
        ],
    },
]

export const yesNo = [
    {
        title: "Sélectionner tout",
        data: [
            {
                label: "Oui",
                value: "1",
            },
            {
                label: "Non",
                value: "0",
            },
        ],
    },
]

export const candidaturesStatus = [
    {
        title: "Sélectionner tout",
        data: [
            {
                label: "Validée",
                value: "validated",
            },
            {
                label: "Refusée",
                value: "rejected",
            },
            {
                label: "En attente",
                value: "pending",
            },
        ],
    },
]

export const skillSetIds = [
    {
        label: "Je maîtrise l’art de l’organisation",
        value: 101,
    },
    {
        label: "Je maîtrise l’art de la concentration",
        value: 102,
    },
    {
        label: "Je maîtrise l’art de l’expression",
        value: 103,
    },
    {
        label: "Je maîtrise l’art de la coopération",
        value: 104,
    },
]

// Result
export const resultBooster = [
    {
        value: "Rendu très satisfaisant",
        text: "Rendu très satisfaisant",
        color: "success",
    },
    {
        value: "Rendu satisfaisant",
        text: "Rendu satisfaisant",
        color: "warning",
    },
    {
        value: "Rendu insatisfaisant",
        text: "Rendu insatisfaisant",
        color: "danger",
    },
]
export const ResponseResult = [
    {
        value: "Pas du tout d'accord",
        text: "Pas du tout d'accord",
    },
    {
        value: "Pas tout à fait d'accord",
        text: "Pas tout à fait d'accord",
    },
    {
        value: "Plutôt d'accord",
        text: "Plutôt d'accord",
    },
    {
        value: "Tout à fait d'accord",
        text: "Tout à fait d'accord",
    },
]

// Survey response
export const surveyResponse = [
    "Pas du tout d'accord",
    "Pas tout à fait d'accord",
    "Plutôt d'accord",
    "Tout à fait d'accord",
]

export const formIds = {
    ACTIVITY: "activity",
    COMPLETE_PROFILE: "complete_profile",
    NEW_MATERIAL: "new-material",
    SEND_TUTOR_MESSAGE: "send-tutor-message",
    LIVE_REPORT_COMMENT: "live-report-comment",
    LIVE_SATISFACTION_COMMENT: "live-satisfaction-comment",
    CHECKPOINT: "checkpoint",
    NEW_SCHOOL_ASSESSMENT: "new-school-assessment",
    ISSUE_REPORT: "issue-report",
    // Photo intermédiaire de la session Sam : identifie le cliché dans
    // state.camera pour que useSamWorkCheck le distingue d'une soumission
    // d'activité classique (qui, elle, termine l'activité).
    SAM_WORK_CHECK: "sam-work-check",
    // Une page de la copie du nouvel espace élève : à elle, sous ce nom, pour que la photo d'un énoncé
    // (`NEW_MATERIAL`, « Ajouter un énoncé » au-dessus de l'activité) ne devienne pas une page.
    ACTIVITY_COPY: "activity-copy",
}

export const liveOccurrenceStatuses = [
    {
        value: "todo",
        label: "À faire",
    },
    {
        value: "pending_review",
        label: "En attente",
    },
    {
        value: "validated",
        label: "Accepté",
    },
    {
        value: "canceled",
        label: "Annulé",
    },
]

export const extendedStudentClasses = [
    { label: "6ème", value: "6ème" },
    { label: "5ème", value: "5ème" },
    { label: "4ème", value: "4ème" },
    { label: "3ème", value: "3ème" },
    { label: "2nde", value: "2nde" },
    { label: "1ère", value: "1ère" },
    { label: "Tle", value: "Tle" },
]

// Attribution Ticket Filters
export const attributionTicketStatusFilter = [
    {
        title: "Sélectionner tout",
        data: [
            { label: "À traiter", value: "todo" },
            { label: "En cours", value: "in_progress" },
            { label: "En attente Parent", value: "waiting_parents" },
            { label: "En attente Tuteur", value: "waiting_tutor" },
            { label: "Surveillance", value: "surveillance" },
            { label: "Clôturé", value: "closed" },
        ],
    },
]

export const attributionTicketStudentMotifFilter = [
    {
        title: "Sélectionner tout",
        data: studentMotifOptions.map(({ value, label }) => ({ label, value })),
    },
]

export const attributionTicketTutorMotifFilter = [
    {
        title: "Sélectionner tout",
        data: tutorMotifOptions.map(({ value, label }) => ({ label, value })),
    },
]

export const attributionTicketUrgencyFilter = [
    {
        title: "Sélectionner tout",
        data: [
            { label: "Urgent", value: "urgent" },
            { label: "Attention", value: "warning" },
            { label: "Normal", value: "normal" },
        ],
    },
]

export const attributionTicketEntityTypeFilter = [
    {
        title: "Sélectionner tout",
        data: [
            { label: "Élèves", value: "student" },
            { label: "Tuteurs", value: "tutor" },
        ],
    },
]

countries.registerLocale(frLocale)

const allCountryNames = countries.getNames("fr")
export const countryOptions = Object.entries(allCountryNames)
    .map(([code, label]) => ({ value: code, label }))
    .sort((a, b) => a.label.localeCompare(b.label, "fr"))

const REQUIRED_MSG = "Ce champ est requis"

export const addressSchema = yup.object({
    parent_firstname: yup.string().required(REQUIRED_MSG),
    parent_lastname: yup.string().required(REQUIRED_MSG),
    street: yup.string().required(REQUIRED_MSG),
    complement: yup.string().nullable(),
    city: yup.string().required(REQUIRED_MSG),
    postal_code: yup
        .string()
        .required(REQUIRED_MSG)
        .when("country", (country, schema) => {
            const code = country?.value
            if (code && postcodeValidatorExistsForCountry(code)) {
                return schema.test(
                    "postcode",
                    "Le code postal est invalide",
                    (value) => !value || postcodeValidator(value, code)
                )
            }
            return schema
        }),
    country: yup.object().required(REQUIRED_MSG),
})
